import { RelationDto } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class RelationResponseModel extends GlobalResponseObject{
    data?: RelationDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //IdProofsTypeDto
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: RelationDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
